const IdentificationType = {
  PASAPORTE: 'PASAPORTE',
  RUT: 'RUT',
  OTRO: 'OTRO',
};

export default IdentificationType;
